/* eslint-disable max-len */
import IMFAOption from "interfaces/IMFAOption";

const mfaOptions = () : IMFAOption[] => [
  {
    id: "SMS_MFA|SMS_MFA",
    heading: "SMS Only",
    subHeading: "Amazon Cognito will send a token one-time password (TOTP) in an SMS message to this user’s verified phone number.",
    sms: true,
    software: false,
    preferredMFA: 1,
    preferredMFAString: "SMS_MFA"
  },
  {
    id: "SMS_MFA,SOFTWARE_TOKEN_MFA|SMS_MFA",
    heading: "SMS if available, otherwise authenticator app",
    subHeading: "If this user does not have a verified phone number, they can enter TOTP from a registered authenticator app.",
    sms: true,
    software: true,
    preferredMFA: 1,
    preferredMFAString: "SMS_MFA"
  },
  {
    id: "SMS_MFA,SOFTWARE_TOKEN_MFA|SOFTWARE_TOKEN_MFA",
    heading: "Authenticator app if available, otherwise SMS",
    subHeading: "This user can enter a TOTP if they have registered an authenticator app. If not, Amazon Cognito will send a TOTP in an SMS message to their verified phone number.",
    sms: true,
    software: true,
    preferredMFA: 2,
    preferredMFAString: "SOFTWARE_TOKEN_MFA"
  },
  {
    id: "SMS_MFA,SOFTWARE_TOKEN_MFA|",
    heading: "Choose preferred delivery method",
    subHeading: "When this user has both SMS and TOTP MFA set up, they will be prompted with an initial selection of their preferred device.",
    sms: true,
    software: true,
    preferredMFA: 0
  },
  {
    id: "SOFTWARE_TOKEN_MFA|SOFTWARE_TOKEN_MFA",
    heading: "Authenticator app only",
    subHeading: "Your app will register this user for TOTP Multi-Factor Authentication (MFA) with an authenticator app.",
    sms: false,
    software: true,
    preferredMFA: 2,
    preferredMFAString: "SOFTWARE_TOKEN_MFA"
  }
];

export { mfaOptions };
